import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";
import { XPLAN_MIGRATION_ROUTE } from "../../../constants/appRoutes";
import SimpleLayout from "../../../layouts/SimpleLayout/SimpleLayout";
import MigrationHomePage from "./IresXplanMigrator/HomePage";

const AusplanAppsPage = () => {
    return (
        <Switch>
            <Route
                exact
                path={XPLAN_MIGRATION_ROUTE}
                component={() => (
                    <SimpleLayout>
                        <MigrationHomePage />
                    </SimpleLayout>
                )}
            />
        </Switch>
    );
};

export default AusplanAppsPage;
